export { default as Popover } from './Popover.vue'
export { default as PopoverTrigger } from './PopoverTrigger.vue'
export { default as PopoverContent } from './PopoverContent.vue'

import { cva, type VariantProps } from 'class-variance-authority'
export const popoverContentVariants = cva(
  'w-60 bg-white border-none p-4 rounded-4xl relative overflow-visible',
  {
    variants: {
      side: {
        right:
          "data-[side=right]:ml-2 before:content-[''] before:absolute before:w-3 before:h-3 before:bg-white before:rotate-45 data-[side=right]:before:left-[-6px] data-[side=right]:before:top-1/2 data-[side=right]:before:-translate-y-1/2",
        left: "data-[side=left]:mr-2 before:content-[''] before:absolute before:w-3 before:h-3 before:bg-white before:rotate-45 data-[side=left]:before:right-[-6px] data-[side=left]:before:top-1/2 data-[side=left]:before:-translate-y-1/2",
        top: "data-[side=top]:mb-2 before:content-[''] before:absolute before:w-3 before:h-3 before:bg-white before:rotate-45 data-[side=top]:before:bottom-[-6px] data-[side=top]:before:left-1/2 data-[side=top]:before:-translate-x-1/2",
        bottom:
          "data-[side=bottom]:mt-2 before:content-[''] before:absolute before:w-3 before:h-3 before:bg-white before:rotate-45 data-[side=bottom]:before:top-[-6px] data-[side=bottom]:before:left-1/2 data-[side=bottom]:before:-translate-x-1/2",
      },
      size: {
        lg: 'w-72 p-5',
        md: 'w-60 p-4',
        sm: 'w-48 p-3',
      },
    },
    defaultVariants: {
      side: 'bottom',
      size: 'md',
    },
  },
)
export const popoverShadowClass = 'drop-shadow-[0_2px_12px_rgba(0,0,0,0.06)]'

export type PopoverContentVariants = VariantProps<typeof popoverContentVariants>
